import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'api';

export interface DecisionBucket {
  id: number;
  count: number;
  decision: string;
  range_from: number;
  range_to: number;
  assessment: number;
}

export interface DecisionBucketsResponse {
  assessment_id: string;
  decision_buckets: DecisionBucket[];
}

/**
 * Hook to fetch decision buckets for an assessment
 */
export const useFetchDecisionBuckets = (assessmentId?: string) => {
  return useQuery({
    queryKey: ['decisionBuckets', assessmentId],
    queryFn: async () => {
      if (!assessmentId) {
        throw new Error('Assessment ID is required');
      }
      const response = await apiClient.get<DecisionBucketsResponse>(
        `/assessment/decision-bucket/?assessment_id=${assessmentId}`
      );
      return response.data;
    },
    enabled: !!assessmentId,
    staleTime: 5 * 60 * 1000,
  });
};
